export enum AuditEvent {
  TenantCreate = 'Tenant:Create',
  TenantDelete = 'Tenant:Delete',
  TenantUpdate = 'Tenant:Update',
  WorkspaceUpdate = 'Workspace:Update',
  UserCreate = 'User:Create',
  UserUpdate = 'User:Update',
  AdminUserUpdate = 'AdminUser:Update',
  UserDelete = 'User:Delete',
  UserPasswordReset = 'Credentials:PasswordResetRequested',
  UserOtpCodeSent = 'Credentials:OtpCodeRequested',
  UserLocked = 'LocalUser:Lock',
  UserLockWarning = 'LocalUser:LockWarning',
  UserLockExpired = 'LocalUser:LockExpired',
  TaniumInstanceLinked = 'TaniumInstance:Link',
  TaniumInstanceUnlinked = 'TaniumInstance:Unlink',
  TaniumInstanceCreate = 'TaniumInstance:Create',
  TaniumInstanceDelete = 'TaniumInstance:Delete',
  TaniumInstanceDeactivated = 'TaniumInstance:Deactivate',
  TaniumInstanceReactivated = 'TaniumInstance:Reactivate',
  TaniumInstanceRemoved = 'TaniumInstance:Remove',
  DomainCreate = 'Domain:Create',
  DomainDelete = 'Domain:Delete',
  IdpCreate = 'Idp:Create',
  IdpUpdate = 'Idp:Update',
  IdpDelete = 'Idp:Delete',
  GettingStartedEmailSent = 'GettingStartedEmail:Sent',
  LinkedInstanceEmailSent = 'LinkedInstanceEmail:Sent',
  LicenseUpdatedEmailSent = 'LicenseUpdatedEmail:Sent',
  LicenseDeliveredInAMP = 'License:DeliveredInAMP',
  InstanceLinkedInAMP = 'Instance:LinkedInAMP',
  OnPremInstanceOnboarded = 'Instance:OnPremOnboarded',
  LicenseDownloadedFromAMP = 'License:DownloadedFromAMP',
  LicenseDeletedFromAMP = 'License:DeletedFromAMP',
  UnlinkedInstanceEmailSent = 'UnlinkedInstanceEmail:Sent',
  IdpCertExpirationEmailSent = 'IdpCertExpirationEmail:Sent',
  LoginIdpError = 'Login:IDPLoginError',
  LoginAuthenticateError = 'Login:AuthenticateError',
  CaseGrantGranted = 'CaseGrant:Grant',
  CaseGrantUpdated = 'CaseGrant:Update',
  CaseGrantRevoked = 'CaseGrant:Revoke',
}

export interface AuditHistoryEventBase {
  username?: string;
  event: AuditEvent;
  createdAt: number;
  message: string;
  email?: string;
  userId?: string;
  tenantId?: string;
  details: any;
}

export interface AuditHistoryResponse {
  data: AuditHistoryEventBase[];
  nextPageCursor: string;
  totalCount: number;
}

export interface AuditHistoryRequest {
  // startTime and endTime should be UTC timestamps
  startTime: number;
  endTime: number;
  limit: number;
  cursor?: string;
  user?: string;
  event?: string;
}
